export default __webpack_public_path__ + "static/smellsLikeWatermelon-dd3f498e5c605dc5be35ec9ba047635d.png";